// extracted by mini-css-extract-plugin
export default {"spinner":"r3EIwANqZEnMQI0FAGS9__spinner___","header":"uf91igo9Gmy8GG4GLY2A__header___","summary":"UNh7JhsX2bGAmMq23mag__summary___"};